/**
 *
 * Scroll to Top - Beim klick zum Seitenanfang hochscrollen
 *
 * Dieses Script triggert ein Button der bei einem gegeben offset eingeblendet wird.
 * Beim klick auf den Button Scrollt die seite bis zum Anfang.
 *
 * @param {string} selectorInjection - Selector in dem der Scrollbutton eingefügt wird
 * @param {number} offSet - Anzahl an Pixeln die gescrollt wird bevor der Scrollbutton angezeigt wird
 *
 * @return {undefined}
 *
 */

function nc_initScrollToTop(selectorInjection, offSet) {
    var moduleLogger = LoggerManager.get('scroll-to-top').setPrefix('SelectorInjection: ' + selectorInjection + 'Offset: ' + offSet);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        nc_scrollToTop(selectorInjection, offSet);
    });
    moduleLogger.info('INIT ENDE');
}

function nc_scrollToTop(selectorInjection, offSet) {
    var moduleLogger = LoggerManager.get('scroll-to-top').setPrefix('SelectorInjection: ' + selectorInjection + 'Offset: ' + offSet);
    moduleLogger.trace('SCRIPT START');

    // Triggerselector als Variable setzen
    var selectorScrollToTop;

    // Scroll Event
    $(window).scroll(function(){
        // Abfragen ob mehr als OffSet als Pixel gescrollt wurde
        if($(this).scrollTop() > offSet) {
            // moduleLogger.info('Es wurde mehr als: ' + offSet + 'px gescrollt. Active Klasse wurde hinzugefügt.');
            // active Klasse auf den Selector setzen
            selectorScrollToTop.addClass("active");
        } else {
            // moduleLogger.info('Es wurde weniger als: ' + offSet + 'px gescrollt. Active Klasse wurde entfernt.');
            // active Klasse vom Selector entfernen
            selectorScrollToTop.removeClass("active");
        }
    });

    /**
     * INITIALISIERUNG DES SCRIPTES
     */

    // Toggler in den SelectorInjection anhängen
    $(selectorInjection).append('<div id="scroll-to-top"><i class="amphiicon"></i></div>');

    // Variablen inhalt mit jQuery Selector definieren
    selectorScrollToTop = $('#scroll-to-top');

    // Event für den Button registrieren
    selectorScrollToTop.on('click', function(e) {
        moduleLogger.info('Button zum hochscrollen wurde geklickt');
        $(window).scrollTop(0);
        e.preventDefault();
    });

    moduleLogger.info('SCRIPT ENDE');
}